import { getText, Tlt } from "@clairejs/react";
import { Modal } from "antd";
import { useState } from "react";

import { RedColor } from "../../../utils/style";

import OtpInput from "../../../components/otp-input";

interface Props {
    otpError?: boolean;
    onChange?: (otp: string) => void;
    verifyOtp?: () => Promise<void>;
    disabled?: boolean;
    onCancel?: () => void;
}
export default function OtpDialog({ onChange, otpError, verifyOtp, disabled, onCancel }: Props) {
    const [progress, setProgress] = useState(false);

    const verify = async () => {
        try {
            setProgress(true);
            await verifyOtp?.();
        } finally {
            setProgress(false);
        }
    };

    return (
        <Modal
            title={getText(<Tlt template="Verify your account" />)}
            open={true}
            maskClosable={false}
            onOk={() => verify()}
            okButtonProps={{ loading: progress, disabled }}
            onCancel={onCancel}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 13,
                    padding: 21,
                }}>
                <div>
                    <Tlt template="Please input the verification code that we sent to your email." />
                </div>
                <OtpInput disabled={progress} onChange={onChange} otpLength={6} />

                <div style={{ color: RedColor }}>
                    {otpError && <Tlt template="The verification code is incorrect." />}
                </div>
            </div>
        </Modal>
    );
}
